"use client";

import { streamControllers, streamKey } from "@/lib/whiteboard/streaming/transport";
import type { ReactNode } from "react";
import { StreamingBoard } from "./StreamingBoard";

export function StreamingCard({
  reference,
  variant,
  embedded,
  headerExtra,
}: {
  reference: { session: string; id: string; revision: number };
  variant?: "photo" | "dark";
  embedded?: boolean;
  headerExtra?: ReactNode;
}) {
  const controller = streamControllers.get(streamKey(reference));
  return controller ? (
    <StreamingBoard
      controller={controller}
      variant={variant}
      embedded={embedded}
      headerExtra={headerExtra}
    />
  ) : (
    <p className="p-4">This practice is no longer available.</p>
  );
}
